import React, { MouseEventHandler } from 'react'
import './alert.css'
import { useAppDispatch, useAppSelector } from '../../store/storeRequests'
import StoreSelectors from '../../utils/constants/StoreSelectors.constants'
import Modal from 'react-bootstrap/Modal'
import closeIcon from '../../assets/close.svg'
import successIcon from '../../assets/checkmark-outlined.svg'
import failureIcon from '../../assets/close-icon.svg'
import { closeAlert } from '../../store/Alert/alert.actions'
import CustomButton from '../CustomButton/CustomButton'

const Alert: React.FunctionComponent<{ proceedCallback?: MouseEventHandler<HTMLButtonElement>, cancelCallback?: MouseEventHandler<HTMLButtonElement> }> =
    ({ proceedCallback, cancelCallback }) => {

    const dispatch = useAppDispatch()
    const alertState = useAppSelector(StoreSelectors.ALERT_STATE)

    const closeAlertPopup = () => {
        typeof cancelCallback !== 'undefined' ?
            dispatch(closeAlert(cancelCallback))
            : 
            dispatch(closeAlert(() => {}))
    }
        
  return (
    <Modal show={ alertState.showAlert } className="alert-modal border-0" backdropClassName='alert-backdrop' backdrop="static">
        <Modal.Header className='justify-content-center border-0 position-relative'>
            {
                !alertState.actionableAlert &&
                <div className="cursor-pointer mf-modal-close" onClick={closeAlertPopup}>
                    <img width="25" height="25" src={closeIcon} alt="close" />
                </div>
            }
            
            {
                alertState.actionableAlert &&
                <>
                    <Modal.Title className='weight-400 font-13 mf-alert-modal-title text-sec-color'>Action required</Modal.Title>
                    <div className="cursor-pointer mf-modal-close" onClick={closeAlertPopup}>
                        <img width="25" height="25" src={closeIcon} alt="close" />
                    </div>
                </>
                
            }
        </Modal.Header>
        <Modal.Body className='alert-modal-body'>
            
            {
                alertState.actionableAlert === false &&
                <div className="alert-modal-img text-center mb-4">
                    <img width={64} height={64} src={ alertState.isSuccess ?  successIcon : failureIcon} alt={alertState.isSuccess ? "success" : "failed"} />
                </div>    
            }
              
                {
                    !alertState.actionableAlert &&
                    <div className="alert-body-message mx-auto">
                        <p className="mb-0 text-primary-color text-center text-capitalize font-16 weight-500">{ alertState.message }</p>
                    </div>
                }
                {
                    alertState.actionableAlert &&
                    <div className="alert-body-message w-100">
                        <p className="mb-4 text-primary-color text-start text-capitalize font-13 weight-400">{ alertState.message }</p>
                    </div>
                }
            
            <div className="alert-action-btns">
                {
                    alertState.actionableAlert === true &&
                    <div className="row no-negative-margin">
                        <div className="col-6 ps-0">
                            <CustomButton type='button' onClick={ closeAlertPopup } theme='outlined'>cancel</CustomButton>
                        </div>
                        <div className="col-6 pe-0">
                            <CustomButton type='button' onClick={ proceedCallback } >proceed</CustomButton>
                        </div>
                    </div>
                }
                {
                    alertState.actionableAlert === false &&
                    <div className="text-center mt-4">
                        <button type='button' className='text-center border-0 close-only-btn text-capitalize weight-600 text-primary-color font-14' onClick={ closeAlertPopup }>close</button>
                    </div>
                }
            </div>
        </Modal.Body>
    </Modal>
  )
}

export default Alert